// this should be the entry point to your library
module.exports = {
    Timeline: require('./Timeline').default, // eslint-disable-line global-require
};